var DOOR_TYPE;
(function (DOOR_TYPE) {
    DOOR_TYPE["Single"] = "Single";
    DOOR_TYPE["Double"] = "Double";
    DOOR_TYPE["Misc"] = "Misc";
})(DOOR_TYPE || (DOOR_TYPE = {}));

export { DOOR_TYPE };
//# sourceMappingURL=door-type.js.map
